import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthSessionService } from '../../features/auth/services/auth-session.service';
import { AuthConfigService } from '../services/auth-config.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const config = inject(AuthConfigService);
  const router = inject(Router);
  const session = inject(AuthSessionService);

  if (!config.enabled || config.bypassLogin || session.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/inicio-sesion'], {
    queryParams: state.url ? { redirectTo: state.url } : undefined,
  });
};
